"use client";

import Script from "next/script";

export function GoogleScriptLoader() {
  return (
    <Script
      src="https://accounts.google.com/gsi/client"
      async
      defer
      onLoad={() => {
        const event = new Event("googleLoaded");
        window.dispatchEvent(event);
      }}
    />
  );
}
